export const DowloandIcon = (props) => (
    <svg
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.74149 14.1383L12.7545 9.66348L12.3724 9.15005L7.06149 13.1023V0.640015H6.42149V13.1023L1.1106 9.15005L0.728516 9.66348L6.74149 14.1383Z"
            fill="#515049"
        />
        <path
            d="M12.5635 15.68H0.919666V16.32H12.5635V15.68Z"
            fill="#515049"
        />
    </svg>
);


export const ToggleSwitch = ({toggled}) => {

    return (
        <svg
            width="39"
            height="21"
            viewBox="0 0 39 21"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Fond du toggle */}
            <rect
                x="0.5"
                y="0.5"
                width="38"
                height="20"
                rx="10"
                fill={toggled ? "#515049" : "#f1eeec"} // change la couleur au toggle
                stroke="#515049"
                style={{
                    transition: "all 0.15s ease", // animation fluide
                }}
            />

            {/* Bouton rond */}
            <circle
                cx={toggled ? 28.5 : 10.5} // déplacement du cercle
                cy="10.5"
                r="6"
                fill="#f1eeec"
                stroke="#515049"
                style={{
                    transition: "all 0.15s ease", // animation fluide
                }}
            />
        </svg>
    );
};